import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsTerrorismAdvocacyItemValidator from './validators/items';
import { LegalAssociationsTerrorismAdvocacyModel } from './types';

const legalAssociationsAdvocacyTerrorismValidator: ValidateJSModel<LegalAssociationsTerrorismAdvocacyModel> = {
  HasTerrorismAdvocacy: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasTerrorismAdvocacy?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsTerrorismAdvocacyItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsAdvocacyTerrorismValidator;
